<template>
  <div :class="props.gridView ? ['grid-cards-container', props.className] : 'd-flex flex-column gap-3'">
    <nuxt-link
      @click="handleAddAnnounce"
      v-if="isDash && width >= breakpoints.screen_laptop"
      class="col d-flex align-items-start add-announce-card"
    >
      <div
        class="cards bg-white h-100 border-dashed border-dashed-primary-600 d-flex flex-column align-items-center  justify-content-center text-center gap-4">
        <div class="avatar avatar-icon bg-primary-25 text-primary-600" style="width: 64px; height:64px;">
          <i class="material-symbols-rounded fsz-24">add_2</i>

        </div>
        <div>
          <h6 class=" fw-semiBold text-primary-600">
            Ajouter une annonce
          </h6>
          <p class="text-gray-500 fsz-12 px-3">
            Commencez à créer votre annonce
            maintenant
          </p>
        </div>
      </div>
    </nuxt-link>
    <!--  -->
    
    <slot v-if="data && data.length" v-for="(add, index) in props.data" :add="add" :index="index" :key="add.id" :isHome="props.isHome"
        :loadMoreRef="(el: any) => index === props.data.length - 5 ? loadMoreElement = el : null">
    </slot>

  </div>
</template>


<script setup lang="ts" >
import { trackAnnouncementStarted } from '~/composables/useFirebaseAnalytics'
import { useWindowSize } from "@vueuse/core";
import { breakpoints } from '~/utils/breakpoints.js';

const { width } = useWindowSize();
const { sendAddAnnouncementTelegram } = useAddAnnouncementTelegram();

const props = defineProps({
  data: {
    type: Array as PropType<announceById[] | sentOffer[]>,
    required: true,
    defualt: []
  },
  className: { type: String, default: '' },
  gridView: { type: Boolean, default: true },
  isDash: { type: Boolean, default: false },
  isHome: { type: Boolean, default: false },
  isScroll: { type: Boolean, default: true },
  callFrom: { type: String, default: '' },
  dataTotalCount: { type: Number, default: 0 },
  userId: { type: Number, default: 0 },
  method: {
    type: Function
  },
  titleFilter: { type: String, default: '' },
  userName:{type: String, default: ''}

})
const loadMoreElement = ref()
const pageNumber = ref(2)
const isLoading = ref(false)
const emit = defineEmits(['update-spinner'])

const handleAddAnnounce = () => {
  if (width.value > breakpoints.screen_laptop) {
    navigateTo('/vendre-voiture')
  } else {
    void sendAddAnnouncementTelegram('manuel')
    trackAnnouncementStarted({ announce_type_created: 'Manuel' })
    navigateTo('/listing-form/vehicle-data?fresh=true')
  }
}

// Helper function to wait for data to update
const waitForDataUpdate = async (currentLength: number, maxAttempts = 50) => {
  let attempts = 0;
  while (props.data.length === currentLength && attempts < maxAttempts) {
    await new Promise(resolve => setTimeout(resolve, 100));
    attempts++;
  }
};

// Load more data based on the call context
const loadMoreData = async (page: number) => {
  const handlers: Record<string, () => Promise<void>> = {
    isSearch: async () => await props.method(page, props.userId),
    isMarket: async () => await props.method(props.userName, page),
    isDash: async () => await props.method(page, true, props.titleFilter, true),
    Saved: async () => await props.method(page, props.titleFilter, true),
  };

  const handler = Object.entries(handlers).find(([key]) => props.callFrom.includes(key))?.[1];
  
  if (handler) {
    await handler();
  }
};

useIntersectionObserver(
  loadMoreElement,
  async ([{ isIntersecting }]) => {
    if (!props.isScroll) return;
    if (isLoading.value) return;
    const canLoadMore = isIntersecting && 
                        props.data?.length && 
                        props.data.length < props.dataTotalCount && 
                        props.method;

    if (!canLoadMore) return;

    try {
      isLoading.value = true;
      emit('update-spinner', true);
      
      const currentDataLength = props.data.length;

      await loadMoreData(pageNumber.value);
      await waitForDataUpdate(currentDataLength);

      if (props.data.length > currentDataLength) {
        pageNumber.value++;
      }
    } finally {
      isLoading.value = false;
      emit('update-spinner', false);
    }
  },
  { threshold: 1 }
);

</script>


<style lang="scss" scoped>
.add-announce-card {
  min-height: 350px;
}

.border-dashed:before {
  border-width: 5px !important;
}
</style>
